/*
  This JS file is used to import dynamically the components depending on the targeted customer.
  First, it will load the default component and then overide those component by those present 
  in the targeted customer.
  If somme components are not in the targeted customer folder, it will keep the default components.
  That allow us to have a default structure and be able to change only the needed component to match the customer needs
*/ 

//--- Load default components first
const requireDefault = require.context(`../component/client/default`, false, /.jsx$/);

const list = {};

requireDefault.keys().forEach((fileName) => {
  const componentConfig = requireDefault(fileName);

  const componentName = fileName
    .replace(/^\.\//, "")
    .replace(/\.\w+$/, "")
    .replace(/jsx/, "");

  const CompTag = componentConfig.default;

  list[componentName] = CompTag;
});

//--- Look in a specific folder .js files
if (process.env.REACT_APP_CLIENT) {
  const requireComponent = require.context(`../component/client/${process.env.REACT_APP_CLIENT}`, false, /.jsx$/);
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);

    const componentName = fileName
      .replace(/^\.\//, "")
      .replace(/\.\w+$/, "")
      .replace(/jsx/, "");

    const CompTag = componentConfig.default;

    list[componentName] = CompTag;
  });
}

export default list;
